import TermsAndConditionsCheckbox from './TermsAndConditionsCheckbox';

export default TermsAndConditionsCheckbox;
